<div class="cockpit-content">
  <h1 translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.title</h1>
  <h2 translate>m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.header</h2>
  <app-chart-download-button (buttonClick)="exportRegressionOutput()">
    <h3 translate>m2.sprint4.cockpit.card.funktionenstatistiken.table</h3>
  </app-chart-download-button>

  <app-regression-output [data]="data?.regressionOutput"></app-regression-output>

  <app-chart-download-button (buttonClick)="exportAusreisserListe()">
    <h3 translate>m2.sprint4.cockpit.card.funktionenstatistiken.table</h3>
  </app-chart-download-button>

  <app-ausreisser-liste [data]="data?.ausreisserListe" [mitarbeiters]="mitarbeiters"></app-ausreisser-liste>
</div>

